/* eslint-disable no-nested-ternary */
import { Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import 'react-toastify/dist/ReactToastify.css';
import useCollection from './hooks/useCollection';
import AddResource from './AddResource';

const useStyles = makeStyles(() => ({
  heading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  collectionText: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
  collectionTextBtn: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: '#622FEE',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    margin: '0px',
  },
  resourceDetailContainer: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));

const LeftSideCollection = () => {
  const classes = useStyles();
  const { fetchCollection: fetchCollectionFromHook } = useCollection();
  const details = useSelector((state) => state.getCollection.collection);
  const [departments, setDepartments] = useState([]);
  const [expertise, setExpertise] = useState('');
  const [isOpenResource, setIsOpenResource] = useState(false);

  useEffect(() => {
    setExpertise(details?.expertiseLevel?.name);
    const temp = details?.categories?.map((item) => item.name).join(',');
    setDepartments(temp);
  }, [details]);

  const fetchCollectionFn = () => {
    if (details?.id) {
      fetchCollectionFromHook(details.id);
    }
  };

  const getValue = () => {
    const type = details?.contentType;
    if (type === 1) {
      return ['ROCKED', 'Internal'];
    }
    if (type === 2) {
      return ['OEM', details?.rnpName];
    }
    if (type === 3) {
      return ['PARTNER', details?.rnpName];
    }
    return ['', ''];
  };

  return (
    <Grid
      className={classes.container}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Grid item>
        <p className={classes.heading}>RESOURCES</p>
        {_.get(details, 'resourceCount', 0) === 0 ? (
          <button
            type="button"
            className={classes.collectionTextBtn}
            onClick={() => setIsOpenResource(true)}
            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
          >
            + Add Resources
          </button>
        ) : (
          <div className={classes.resourceDetailContainer}>
            <p className={classes.collectionText} style={{ margin: 0 }}>
              {`${_.get(details, 'resourceCount', 0)} ${
                _.get(details, 'resourceCount', 0) === 1 ? 'resource' : 'resources'
              } added`}
            </p>
            <button type="button" className={classes.collectionTextBtn} onClick={() => setIsOpenResource(true)}>
              View Resources
            </button>
          </div>
        )}
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION NAME</p>
        <p className={classes.collectionText}>{details?.title}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION TAGLINE</p>
        <p className={classes.collectionText}>{details?.goal}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION DESCRIPTION</p>
        <p className={classes.collectionText}>{details?.description}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION ENABLED</p>
        <p className={classes.collectionText}>{`${details?.enabled ?? ''}`}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION DEPARTMENTS</p>
        <p className={classes.collectionText}>{departments}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>COLLECTION EXPERTISE LEVEL</p>
        <p className={classes.collectionText}>{expertise}</p>
      </Grid>
      <Grid item>
        <p className={classes.heading}>{getValue()[0]}</p>
        <p className={classes.collectionText}>{getValue()[1]}</p>
      </Grid>

      {isOpenResource && (
        <AddResource
          isOpen={isOpenResource}
          close={() => setIsOpenResource(false)}
          collectionId={details?.id}
          fetchCollection={fetchCollectionFn}
        />
      )}
    </Grid>
  );
};

export default LeftSideCollection;
